import { useState } from "react";
import { useDispatch } from "react-redux";
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import { getTranslateByKey } from "@/main/services/utils";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import Button from "@/main/components/shared/button/button";
import { quoteApi } from "@/main/api";
import { useCreateOrderContext } from "../../context";
import { loadCart } from "@/main/store/cart";

import * as S from "./styles";

function ModalReQuote() {
	const { guidQuote, openModalReQuote, setOpenModalReQuote, loadInfoOrder } = useCreateOrderContext();

	const [loadingRequote, setLoadingRequote] = useState<boolean>(false);
	const dispatch = useDispatch();

	function handleRequote() {
		setLoadingRequote(true);
		if (guidQuote) {
			quoteApi
				.reQuote(String(guidQuote))
				.then(() => {
					loadInfoOrder(guidQuote);
					dispatch(loadCart(guidQuote));
				})
				.finally(() => {
					setLoadingRequote(false);
					setOpenModalReQuote(false);
				});
		}
	}
	return (
		<KogModalFadeComponent open={openModalReQuote} setOpen={setOpenModalReQuote}>
			<S.BoxModal>
				<S.TitleModal>{getTranslateByKey("information.areYouSureYouWantToReopenOffer")}</S.TitleModal>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						gap: "1rem",
					}}
				>
					<SecondaryButton type="button" onClick={() => setOpenModalReQuote(false)}>
						{getTranslateByKey("information.no")}
					</SecondaryButton>
					<Button type="button" onClick={() => handleRequote()} isLoading={loadingRequote}>
						{getTranslateByKey("information.yes")}
					</Button>
				</div>
			</S.BoxModal>
		</KogModalFadeComponent>
	);
}

export default ModalReQuote;
